import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface ICreatedCompanySummary {
  id: string;
  company_name: string;
}

export interface ICompanyState {
  currentCompanyId: string | undefined;
  showCompanyEditor: boolean;
  latestCreatedCompany?: ICreatedCompanySummary;
}

const initialState: ICompanyState = {
  currentCompanyId: undefined,
  showCompanyEditor: false,
  latestCreatedCompany: undefined,
};

export const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    showCompanyEditor: (state, action: PayloadAction<string | undefined>) => {
      state.showCompanyEditor = true;
      state.currentCompanyId = action.payload;
    },
    hideCompanyEditor: (state) => {
      state.showCompanyEditor = false;
      state.currentCompanyId = undefined;
    },
    setLatestCreatedCompany: (state, action: PayloadAction<ICreatedCompanySummary | undefined>) => {
      state.latestCreatedCompany = action.payload;
    },
    clearLatestCreatedCompany: (state) => {
      state.latestCreatedCompany = undefined;
    }
  },
});

export const { showCompanyEditor, hideCompanyEditor, setLatestCreatedCompany, clearLatestCreatedCompany } = companySlice.actions;
export const authReducer = companySlice.reducer;
